// extracted by mini-css-extract-plugin
module.exports = {"signup":"SignUp_signup__pwMmx"};